import { useEffect, useState } from 'react';

interface LogoProps {
  className?: string;
  size?: number;
}

export function Logo({ className = '', size = 56 }: LogoProps) {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setRotation((prev) => (prev + 0.5) % 360);
    }, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`relative ${className}`} style={{ width: size, height: size }}>
      {/* Animated glow ring */}
      <div
        className="absolute inset-0 rounded-2xl bg-gradient-to-br from-purple-500/30 to-blue-500/30 blur-xl animate-pulse"
        style={{
          transform: `rotate(${rotation}deg)`,
        }}
      />
      
      {/* Logo container */}
      <div className="relative w-full h-full rounded-2xl bg-gradient-to-br from-purple-600 via-purple-500 to-blue-500 p-0.5 shadow-xl shadow-purple-500/50">
        <div className="w-full h-full rounded-2xl bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <img 
            src="/logo.webp" 
            alt="NostrStore Logo" 
            className="w-4/5 h-4/5 object-contain drop-shadow-2xl"
            style={{
              filter: 'drop-shadow(0 0 10px rgba(168, 85, 247, 0.6))',
            }}
          />
        </div>
      </div>

      {/* Sparkle effect */}
      <div
        className="absolute -top-1 -right-1 w-3 h-3 bg-purple-400 rounded-full animate-ping"
        style={{
          animationDuration: '2s',
        }}
      />
    </div>
  );
}
